import React,  {useEffect} from 'react'
import PMCReRegUpcommingForm from './PMCReRegUpcommingForm';
import {useDispatch,  useSelector } from 'react-redux';
import { setPMCReRegSoftLaunch } from '../../store/actions';
import { useHistory } from 'react-router-dom';
const PMCSOftLaunch = () => {
    const reload = useSelector(state => state.registrations.reload);
    const pmcReregData = useSelector(state => state.isReReg.pmcReregData);  
    const registrationsLoading = useSelector((state) => state.registrations.loading);
    const pmcReRegActive = JSON.parse(localStorage.getItem('PMCReRegStatus'));  
    const dispatch = useDispatch();
    const history = useHistory();
    useEffect(() => {
        let isMounted = true;    
        if (registrationsLoading) return;
        if(pmcReregData && pmcReregData.length > 0 && pmcReRegActive){
            // dispatch(setPMCReRegSoftLaunch(pmcReregData));
        }else{
            dispatch(setPMCReRegSoftLaunch(null));
            history.push('/home');
        }
        return () => {
            isMounted = false;
        };
    }, [reload, registrationsLoading]);

    return (
        <div className="launch__wrappper border-0">
        {pmcReregData && pmcReregData.map((item, ind) => <PMCReRegUpcommingForm key={ind} data={item}/>)}
        </div>
    )
}

export default PMCSOftLaunch